/* eslint-disable no-unused-vars */
/**
 * © [2023] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */

export const GET_CURRENT_DISPUTE_DISPLAY_OBJ_ROSI =
  'GET_CURRENT_DISPUTE_DISPLAY_OBJ_ROSI';
export const GET_CURRENT_DISPUTE_DISPLAY_DETAIL_OBJ_ROSI =
  'GET_CURRENT_DISPUTE_DISPLAY_DETAIL_OBJ_ROSI';
export const GET_PLAN_TYPE_DATA_ROSI = 'GET_PLAN_TYPE_DATA';
export const GET_REBATE_PROGRAM_ROSI = 'GET_REBATE_PROGRAM';
export const GET_ERROR_MSG_ROSI = 'GET_ERROR_MSG_ROSI';
export const LEFT_SIDE_TABLEDETAILS = 'LEFT_SIDE_TABLEDETAILS';
export const RIGHT_SIDE_TABLEDETAILS = 'RIGHT_SIDE_TABLEDETAILS';
export const DUPLICATE_ERRORS = 'DUPLICATE_ERRORS';
export const NDC_LOADING = 'NDC_LOADING';
export const MANUFACTURER_GRID_ROSI = 'MANUFACTURER_GRID_ROSI';
export const GRID_MFG_ROSI = 'GRID_MFG_ROSI';
export const GRID_NDC_ROSI = 'GRID_NDC_ROSI';
export const SELECT_OPTION = 'SELECT_OPTION';
export const SELECT_SEARCH_TYPE = 'SELECT_SEARCH_TYPE';
export const GET_FROM = 'GET_FROM';
export const GET_INDEX = 'GET_INDEX';
export const SET_DISPLAY_OBJ_ROSI = 'SET_DISPLAY_OBJ_ROSI';

export const GET_ERROR_MSG_NDC_DETAILS = 'GET_ERROR_MSG_NDC_DETAILS';
export const GET_REBATE_PROGRAM_NAME_ROSI = 'GET_REBATE_PROGRAM_NAME_ROSI';
export const GET_ALL_LABELER_ROSI = 'GET_ALL_LABELER_ROSI';
export const SET_REFRESH_DATA_ROSI = 'SET_REFRESH_DATA_ROSI';
export const GET_MANUFACTURER_NAME_ROSI = 'GET_MANUFACTURER_NAME_ROSI';
export const GET_MANUFACTURER_ID_ROSI = 'GET_MANUFACTURER_ID_ROSI';
export const GET_DRUG_DATA_ROSI = 'GET_DRUG_DATA_ROSI';
export const GET_ROSI_GRID_DATA = 'GET_ROSI_GRID_DATA';
export const GET_PQAS_GRID_DATA = 'GET_PQAS_GRID_DATA';
export const SET_REFRESH_DATA_ROSI_DISPLAY = 'SET_REFRESH_DATA_ROSI_DISPLAY';
export const SET_PAGINATION_INDEX_ROSI_PQAS = 'SET_PAGINATION_INDEX_ROSI_PQAS';
